import React from 'react'
import { useTheme } from '@mui/material/styles'
import logoImage from './images/logo.png' // Update

export const Logo = (props) => {
  const theme = useTheme()
  return (
    <img
      src={logoImage}
      alt="Logo"
      width={40} // Update
      height={40} // Update
      // style={{
      //   filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      // }}
      {...props}
    />
  )
}
